export class SearchConstants {
  static debouceTime = 300;
  static autocompleteMinSearchLength = 2;
  static maxRecentSearches = 3;
  static maxAutocompleteSuggestions = 100;
}
